<template>
  <b-container fluid class="separator text-center">
    <b-row class="separator-row" align-v="center">
      <b-col>
        <h2 class="phrase">
          Monitoreo Total, Calidad y Unidades de Vanguardia son los Elementos que Definen Nuestros Servicio.
        </h2>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {

}
</script>

<style>
.separator{
  background-image: url("../assets/Separator.jpeg");
  height: 75vh;
  background-size:cover;
  background-repeat: no-repeat;
  background-position: bottom right;
}
.phrase{
  font-size: 5vh;
  color: white;
}
.separator-row{
  height: 100%;
}
@media (max-width: 768px) {
  .separator{
    height: 50vh;
  }
}
</style>
